import { ModuleFields } from "~/Utils/drilldownData";
import { SubsidiaryKey } from "./types";

export const subsidiariesDrillDownData = (key: SubsidiaryKey) => {
  const allDrillDownData: Record<SubsidiaryKey, ModuleFields[]> = {
    malaysiaAirportsSepangSdnBhd: [
      {
        fieldName: "Title (EN)",
        fieldValue: `data.items[0].title`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsSepangSdnBhd_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: `data.items[0].markup`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsSepangSdnBhd_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      {
        fieldName: "Title (MS)",
        fieldValue: `data.items[0].title`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsSepangSdnBhd_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: `data.items[0].markup`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsSepangSdnBhd_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
        //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_malaysiaAirportsSepangSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: `data.items[0].title`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsSepangSdnBhd_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: `data.items[0].markup`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsSepangSdnBhd_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
//       {
//         fieldName: "Next Page Name (EN)",
//         fieldValue: "data.nextPage.name",
//         parseField: "field_content_english",
//         className: "col-span-6",
//         type: "content",
//         name: "field_content_english_malaysiaAirportsSepangSdnBhd_nextPage_name",
//         formType: "input",
//         label: "Next Page Name (EN)",
//         placeholder: "Enter content Next Page Name (EN)",
//         validation: { required: "Content Next Page Name (EN) is required" },
//       },
//       {
//         fieldName: "Next Page Name (MS)",
//         fieldValue: "data.nextPage.name",
//         parseField: "field_content_malay",
//         className: "col-span-6",
//         type: "content",
//         name: "field_content_malay_malaysiaAirportsSepangSdnBhd_nextPage_name",
//         formType: "input",
//         label: "Next Page Name (MS)",
//         placeholder: "Enter Next Page Name (MS)",
//       },
//       {
//         fieldName: "Next Page Name (ZH)",
//         fieldValue: "data.nextPage.name",
//         parseField: "field_content_mandarin",
//         className: "col-span-6",
//         type: "content",
//         name: "field_content_mandarin_malaysiaAirportsSepangSdnBhd_nextPage_name",
//         formType: "input",
//         label: "Next Page Name (ZH)",
//         placeholder: "Enter Next Page Name (ZH)",
//       },
//       {
//           fieldName: "Next Page Link",
//           fieldValue: "data.nextPage.link",
//           parseField: "field_content_english",
//           className: "col-span-6",
//         type: "content",
//         name: "field_content_english_malaysiaAirportsSepangSdnBhd_nextPage_link",
//         formType: "input",
//         label: "Next Page Link",
//         placeholder: "Enter content Next Page Link",
//         validation: { required: "Content Next Page Link is required", validate: (value: string) => {
//   const trimmed = value.trim();
//   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
//   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
//     return "Looks like an external link. Please use an in-app page link, such as /example";
//   }
//   return true;
// } },
//       },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsSepangSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],

    malaysiaAirportsSdnBhd: [
      {
        fieldName: "Title (EN)",
        fieldValue: `data.items[1].title`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsSdnBhd_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: `data.items[1].markup`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsSdnBhd_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      // {
      //   fieldName: "Next Page Name (EN)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_malaysiaAirportsSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (EN)",
      //   placeholder: "Enter content Next Page Name (EN)",
      //   validation: { required: "Content Next Page Name (EN) is required" },
      // },
      // {
      //   fieldName: "Next Page Link (EN)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_malaysiaAirportsSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (EN)",
      //   placeholder: "Enter content Next Page Link (EN)",
      //   validation: { required: "Content Next Page Link (EN) is required" },
      // },
      {
        fieldName: "Title (MS)",
        fieldValue: `data.items[1].title`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsSdnBhd_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: `data.items[1].markup`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsSdnBhd_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
      //   fieldName: "Next Page Name (MS)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_malaysiaAirportsSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (MS)",
      //   placeholder: "Enter Next Page Name (MS)",
      // },
      // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_malaysiaAirportsSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: `data.items[1].title`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsSdnBhd_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: `data.items[1].markup`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsSdnBhd_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
      // {
      //   fieldName: "Next Page Name (ZH)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (ZH)",
      //   placeholder: "Enter Next Page Name (ZH)",
      // },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],

    malaysiaAirportsNiagaSdnBhd: [
      {
        fieldName: "Title (EN)",
        fieldValue: `data.items[2].title`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsNiagaSdnBhd_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: `data.items[2].markup`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsNiagaSdnBhd_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      // {
      //   fieldName: "Next Page Name (EN)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_malaysiaAirportsNiagaSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (EN)",
      //   placeholder: "Enter content Next Page Name (EN)",
      //   validation: { required: "Content Next Page Name (EN) is required" },
      // },
      // {
      //   fieldName: "Next Page Link (EN)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_malaysiaAirportsNiagaSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (EN)",
      //   placeholder: "Enter content Next Page Link (EN)",
      //   validation: { required: "Content Next Page Link (EN) is required" },
      // },
      {
        fieldName: "Title (MS)",
        fieldValue: `data.items[2].title`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsNiagaSdnBhd_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: `data.items[2].markup`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsNiagaSdnBhd_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
      //   fieldName: "Next Page Name (MS)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_malaysiaAirportsNiagaSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (MS)",
      //   placeholder: "Enter Next Page Name (MS)",
      // },
      // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_malaysiaAirportsNiagaSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: `data.items[2].title`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsNiagaSdnBhd_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: `data.items[2].markup`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsNiagaSdnBhd_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
      // {
      //   fieldName: "Next Page Name (ZH)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsNiagaSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (ZH)",
      //   placeholder: "Enter Next Page Name (ZH)",
      // },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsNiagaSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],

    malaysiaAirportsConsultancyServicesSdnBhd: [
      {
        fieldName: "Title (EN)",
        fieldValue: `data.items[3].title`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsConsultancyServicesSdnBhd_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: `data.items[3].markup`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsConsultancyServicesSdnBhd_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      // {
      //   fieldName: "Next Page Name (EN)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_malaysiaAirportsConsultancyServicesSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (EN)",
      //   placeholder: "Enter content Next Page Name (EN)",
      //   validation: { required: "Content Next Page Name (EN) is required" },
      // },
      // {
      //   fieldName: "Next Page Link (EN)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_malaysiaAirportsConsultancyServicesSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (EN)",
      //   placeholder: "Enter content Next Page Link (EN)",
      //   validation: { required: "Content Next Page Link (EN) is required" },
      // },
      {
        fieldName: "Title (MS)",
        fieldValue: `data.items[3].title`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsConsultancyServicesSdnBhd_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: `data.items[3].markup`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsConsultancyServicesSdnBhd_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
      //   fieldName: "Next Page Name (MS)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_malaysiaAirportsConsultancyServicesSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (MS)",
      //   placeholder: "Enter Next Page Name (MS)",
      // },
      // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_malaysiaAirportsConsultancyServicesSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: `data.items[3].title`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsConsultancyServicesSdnBhd_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: `data.items[3].markup`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsConsultancyServicesSdnBhd_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
      // {
      //   fieldName: "Next Page Name (ZH)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsConsultancyServicesSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (ZH)",
      //   placeholder: "Enter Next Page Name (ZH)",
      // },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsConsultancyServicesSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],

    klAirportsHotelSdnBhd: [
      {
        fieldName: "Title (EN)",
        fieldValue: `data.items[4].title`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_klAirportsHotelSdnBhd_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: `data.items[4].markup`,
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_klAirportsHotelSdnBhd_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      // {
      //   fieldName: "Next Page Name (EN)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_klAirportsHotelSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (EN)",
      //   placeholder: "Enter content Next Page Name (EN)",
      //   validation: { required: "Content Next Page Name (EN) is required" },
      // },
      // {
      //   fieldName: "Next Page Link (EN)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_klAirportsHotelSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (EN)",
      //   placeholder: "Enter content Next Page Link (EN)",
      //   validation: { required: "Content Next Page Link (EN) is required" },
      // },
      {
        fieldName: "Title (MS)",
        fieldValue: `data.items[4].title`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_klAirportsHotelSdnBhd_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: `data.items[4].markup`,
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_klAirportsHotelSdnBhd_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
      //   fieldName: "Next Page Name (MS)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_klAirportsHotelSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (MS)",
      //   placeholder: "Enter Next Page Name (MS)",
      // },
      // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_klAirportsHotelSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: `data.items[4].title`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_klAirportsHotelSdnBhd_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: `data.items[4].markup`,
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_klAirportsHotelSdnBhd_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
      // {
      //   fieldName: "Next Page Name (ZH)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_klAirportsHotelSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (ZH)",
      //   placeholder: "Enter Next Page Name (ZH)",
      // },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_klAirportsHotelSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],

    mabAgricultureHorticultureSdnBhd: [
      {
        fieldName: "Title (EN)",
        fieldValue: "data.items[5].title",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_mabAgricultureHorticultureSdnBhd_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: "data.items[5].markup",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_mabAgricultureHorticultureSdnBhd_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      // {
      //   fieldName: "Next Page Name (EN)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_mabAgricultureHorticultureSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (EN)",
      //   placeholder: "Enter content Next Page Name (EN)",
      //   validation: { required: "Content Next Page Name (EN) is required" },
      // },
      // {
      //   fieldName: "Next Page Link (EN)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_mabAgricultureHorticultureSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (EN)",
      //   placeholder: "Enter content Next Page Link (EN)",
      //   validation: { required: "Content Next Page Link (EN) is required" },
      // },
      {
        fieldName: "Title (MS)",
        fieldValue: "data.items[5].title",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_mabAgricultureHorticultureSdnBhd_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: "data.items[5].markup",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_mabAgricultureHorticultureSdnBhd_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
      //   fieldName: "Next Page Name (MS)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_mabAgricultureHorticultureSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (MS)",
      //   placeholder: "Enter Next Page Name (MS)",
      // },
      // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_mabAgricultureHorticultureSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: "data.items[5].title",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_mabAgricultureHorticultureSdnBhd_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: "data.items[5].markup",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_mabAgricultureHorticultureSdnBhd_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
      // {
      //   fieldName: "Next Page Name (ZH)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_mabAgricultureHorticultureSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (ZH)",
      //   placeholder: "Enter Next Page Name (ZH)",
      // },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_mabAgricultureHorticultureSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],

    urusanTeknologiWawasanSdnBhd: [
      {
        fieldName: "Title (EN)",
        fieldValue: "data.items[6].title",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_urusanTeknologiWawasanSdnBhd_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: "data.items[6].markup",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_urusanTeknologiWawasanSdnBhd_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      // {
      //   fieldName: "Next Page Name (EN)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_urusanTeknologiWawasanSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (EN)",
      //   placeholder: "Enter content Next Page Name (EN)",
      //   validation: { required: "Content Next Page Name (EN) is required" },
      // },
      // {
      //   fieldName: "Next Page Link (EN)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_urusanTeknologiWawasanSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (EN)",
      //   placeholder: "Enter content Next Page Link (EN)",
      //   validation: { required: "Content Next Page Link (EN) is required" },
      // },
      {
        fieldName: "Title (MS)",
        fieldValue: "data.items[6].title",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_urusanTeknologiWawasanSdnBhd_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: "data.items[6].markup",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_urusanTeknologiWawasanSdnBhd_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
      //   fieldName: "Next Page Name (MS)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_urusanTeknologiWawasanSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (MS)",
      //   placeholder: "Enter Next Page Name (MS)",
      // },
      // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_urusanTeknologiWawasanSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: "data.items[6].title",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_urusanTeknologiWawasanSdnBhd_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: "data.items[6].markup",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_urusanTeknologiWawasanSdnBhd_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
      // {
      //   fieldName: "Next Page Name (ZH)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_urusanTeknologiWawasanSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (ZH)",
      //   placeholder: "Enter Next Page Name (ZH)",
      // },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_urusanTeknologiWawasanSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],

    kliaAeropolisSdnBhd: [
      {
        fieldName: "Title (EN)",
        fieldValue: "data.items[7].title",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_kliaAeropolisSdnBhd_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: "data.items[7].markup",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_kliaAeropolisSdnBhd_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      // {
      //   fieldName: "Next Page Name (EN)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_kliaAeropolisSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (EN)",
      //   placeholder: "Enter content Next Page Name (EN)",
      //   validation: { required: "Content Next Page Name (EN) is required" },
      // },
      // {
      //   fieldName: "Next Page Link (EN)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_kliaAeropolisSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (EN)",
      //   placeholder: "Enter content Next Page Link (EN)",
      //   validation: { required: "Content Next Page Link (EN) is required" },
      // },
      {
        fieldName: "Title (MS)",
        fieldValue: "data.items[7].title",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_kliaAeropolisSdnBhd_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: "data.items[7].markup",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_kliaAeropolisSdnBhd_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
      //   fieldName: "Next Page Name (MS)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_kliaAeropolisSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (MS)",
      //   placeholder: "Enter Next Page Name (MS)",
      // },
      // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_kliaAeropolisSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: "data.items[7].title",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_kliaAeropolisSdnBhd_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: "data.items[7].markup",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_kliaAeropolisSdnBhd_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
      // {
      //   fieldName: "Next Page Name (ZH)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_kliaAeropolisSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (ZH)",
      //   placeholder: "Enter Next Page Name (ZH)",
      // },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_kliaAeropolisSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],

    isgSgc: [
      {
        fieldName: "Title (EN)",
        fieldValue: "data.items[8].title",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_isgSgc_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: "data.items[8].markup",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_isgSgc_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      // {
      //   fieldName: "Next Page Name (EN)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_isgSgc_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (EN)",
      //   placeholder: "Enter content Next Page Name (EN)",
      //   validation: { required: "Content Next Page Name (EN) is required" },
      // },
      // {
      //   fieldName: "Next Page Link (EN)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_isgSgc_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (EN)",
      //   placeholder: "Enter content Next Page Link (EN)",
      //   validation: { required: "Content Next Page Link (EN) is required" },
      // },
      {
        fieldName: "Title (MS)",
        fieldValue: "data.items[8].title",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_isgSgc_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: "data.items[8].markup",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_isgSgc_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
      //   fieldName: "Next Page Name (MS)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_isgSgc_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (MS)",
      //   placeholder: "Enter Next Page Name (MS)",
      // },
      // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_isgSgc_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: "data.items[8].title",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_isgSgc_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: "data.items[8].markup",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_isgSgc_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
      // {
      //   fieldName: "Next Page Name (ZH)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_isgSgc_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (ZH)",
      //   placeholder: "Enter Next Page Name (ZH)",
      // },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_isgSgc_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],
    malaysiaAirportsPropertiesSdnBhd: [
      {
        fieldName: "Title (EN)",
        fieldValue: "data.items[9].title",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsPropertiesSdnBhd_title",
        formType: "input",
        label: "Title (EN)",
        placeholder: "Enter Title (EN)",
        validation: { required: "Title (EN) is required" },
      },
      {
        fieldName: "Markup (EN)",
        fieldValue: "data.items[9].markup",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_malaysiaAirportsPropertiesSdnBhd_markup",
        formType: "richText",
        label: "Markup (EN)",
        placeholder: "Enter Markup (EN)",
        validation: { required: "Markup (EN) is required" },
      },
      // {
      //   fieldName: "Next Page Name (EN)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_malaysiaAirportsPropertiesSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (EN)",
      //   placeholder: "Enter content Next Page Name (EN)",
      //   validation: { required: "Content Next Page Name (EN) is required" },
      // },
      // {
      //   fieldName: "Next Page Link (EN)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_english",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_english_malaysiaAirportsPropertiesSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (EN)",
      //   placeholder: "Enter content Next Page Link (EN)",
      //   validation: { required: "Content Next Page Link (EN) is required" },
      // },
      {
        fieldName: "Title (MS)",
        fieldValue: "data.items[9].title",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsPropertiesSdnBhd_title",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
      },
      {
        fieldName: "Markup (MS)",
        fieldValue: "data.items[9].markup",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_malaysiaAirportsPropertiesSdnBhd_markup",
        formType: "richText",
        label: "Markup (MS)",
        placeholder: "Enter Markup (MS)",
      },
      // {
      //   fieldName: "Next Page Name (MS)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_malaysiaAirportsPropertiesSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (MS)",
      //   placeholder: "Enter Next Page Name (MS)",
      // },
      // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_malay_malaysiaAirportsPropertiesSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      // },
      {
        fieldName: "Title (ZH)",
        fieldValue: "data.items[9].title",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsPropertiesSdnBhd_title",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
      },
      {
        fieldName: "Markup (ZH)",
        fieldValue: "data.items[9].markup",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_malaysiaAirportsPropertiesSdnBhd_markup",
        formType: "richText",
        label: "Markup (ZH)",
        placeholder: "Enter Markup (ZH)",
      },
      // {
      //   fieldName: "Next Page Name (ZH)",
      //   fieldValue: "data.nextPage.name",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsPropertiesSdnBhd_nextPage_name",
      //   formType: "input",
      //   label: "Next Page Name (ZH)",
      //   placeholder: "Enter Next Page Name (ZH)",
      // },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsPropertiesSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ],
    nextPageForSubsidiaries: [
      {
        fieldName: "Next Page Name (EN)",
        fieldValue: "data.nextPage.name",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_nextPage_name",
        formType: "input",
        label: "Next Page Name (EN)",
        placeholder: "Enter content Next Page Name (EN)",
        validation: { required: "Content Next Page Name (EN) is required" },
      },
      {
        fieldName: "Next Page Name (MS)",
        fieldValue: "data.nextPage.name",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_malay_nextPage_name",
        formType: "input",
        label: "Next Page Name (MS)",
        placeholder: "Enter Next Page Name (MS)",
      },
      {
        fieldName: "Next Page Name (ZH)",
        fieldValue: "data.nextPage.name",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_mandarin_nextPage_name",
        formType: "input",
        label: "Next Page Name (ZH)",
        placeholder: "Enter Next Page Name (ZH)",
      },
      {
          fieldName: "Next Page Link",
          fieldValue: "data.nextPage.link",
          parseField: "field_content_english",
          className: "col-span-6",
        type: "content",
        name: "field_content_english_nextPage_link",
        formType: "input",
        label: "Next Page Link",
        placeholder: "Enter content Next Page Link",
        validation: { required: "Content Next Page Link is required", validate: (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
  if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    return "Looks like an external link. Please use an in-app page link, such as /example";
  }
  return true;
} },
      },
      // {
      //   fieldName: "Next Page Link (ZH)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_mandarin",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_mandarin_malaysiaAirportsSepangSdnBhd_nextPage_link",
      //   formType: "input",
      //   label: "Next Page Link (ZH)",
      //   placeholder: "Enter Next Page Link (ZH)",
      // },
    ]
  };

  return allDrillDownData[key];
};
